import * as z$1 from "zod/v4";
//#region src/organization-join-request.ts
const id = z$1.string().trim().min(1).max(255);
const organizationJoinRequestSchema = z$1.strictObject({
	id,
	organizationId: id,
	spaceId: id.nullable(),
	requestedByUserId: id,
	email: z$1.email(),
	status: z$1.enum([
		"pending",
		"approved",
		"rejected",
		"cancelled"
	]),
	reviewedByUserId: id.nullable(),
	createdAt: z$1.number().int().nonnegative(),
	reviewedAt: z$1.number().int().nonnegative().nullable(),
	invitationSentAt: z$1.number().int().nonnegative().nullable(),
	applicantUserId: id.nullable().optional(),
	joinedAt: z$1.number().int().nonnegative().nullable().optional(),
	canReview: z$1.boolean().optional(),
	organizationName: z$1.string().optional(),
	requestedByName: z$1.string().optional(),
	reviewedByName: z$1.string().nullable().optional(),
	spaceName: z$1.string().nullable().optional()
});
const organizationJoinRequestInputSchema = z$1.discriminatedUnion("action", [
	z$1.strictObject({
		action: z$1.literal("create"),
		organizationId: id,
		spaceId: id.optional(),
		email: z$1.string().trim().toLowerCase().pipe(z$1.email())
	}),
	z$1.strictObject({
		action: z$1.literal("list"),
		organizationId: id,
		before: z$1.strictObject({
			createdAt: z$1.number().int().nonnegative(),
			id,
			pending: z$1.boolean()
		}).optional()
	}),
	z$1.strictObject({
		action: z$1.literal("summary"),
		organizationId: id
	}),
	z$1.strictObject({
		action: z$1.literal("get"),
		requestId: id
	}),
	z$1.strictObject({
		action: z$1.literal("approve"),
		requestId: id
	}),
	z$1.strictObject({
		action: z$1.literal("retry"),
		requestId: id
	}),
	z$1.strictObject({
		action: z$1.literal("reject"),
		requestId: id
	}),
	z$1.strictObject({
		action: z$1.literal("cancel"),
		requestId: id
	})
]);
const organizationJoinRequestRpcInputSchema = z$1.strictObject({
	responseVersion: z$1.enum(["2", "3"]).optional(),
	userId: id,
	email: z$1.email(),
	emailVerified: z$1.boolean(),
	request: z$1.union([
		organizationJoinRequestInputSchema,
		z$1.strictObject({
			action: z$1.literal("delivery_complete"),
			requestId: id
		}),
		z$1.strictObject({
			action: z$1.literal("join_complete"),
			requestId: id
		}),
		z$1.strictObject({
			action: z$1.literal("authorize_link"),
			organizationId: id,
			spaceId: id.optional()
		}),
		z$1.strictObject({
			action: z$1.literal("create_from_link"),
			organizationId: id,
			spaceId: id.optional(),
			sponsorUserId: id
		})
	])
});
const organizationJoinRequestResponseSchema = z$1.discriminatedUnion("ok", [z$1.strictObject({
	ok: z$1.literal(true),
	requests: z$1.array(organizationJoinRequestSchema),
	actionRequiredCount: z$1.number().int().nonnegative().optional()
}), z$1.strictObject({
	ok: z$1.literal(false),
	code: id,
	message: z$1.string()
})]);
function organizationJoinRequestResponseForVersion(result, version) {
	if (!result.ok || version === "3") return result;
	return {
		...result,
		requests: result.requests.map(({ reviewedByName: _reviewer, applicantUserId, joinedAt, ...request }) => version === "2" ? {
			...request,
			applicantUserId,
			joinedAt
		} : request)
	};
}
//#endregion
export { organizationJoinRequestInputSchema, organizationJoinRequestResponseForVersion, organizationJoinRequestResponseSchema, organizationJoinRequestRpcInputSchema, organizationJoinRequestSchema };

//# sourceMappingURL=organization-join-request.js.map